import { useGetList } from "#hooks/adapters/adapterUtils";
import { useQueryClient } from "@tanstack/react-query";
import { Resources, DeviceAdapter } from "@validereinc/domain";

export const useListDevices = useGetList(
  DeviceAdapter.getList,
  Resources.DEVICE
);

export const useClearDeviceCache = () => {
  const queryClient = useQueryClient();
  return {
    invalidate: () => {
      queryClient.invalidateQueries({ queryKey: [Resources.DEVICE] });
    },
  };
};
